import { useState, useEffect, useRef, useCallback } from 'react';

export default function CarrosselDestaque({ slides }) {
  const [atual, setAtual] = useState(0);
  const timerRef = useRef(null);
  const touchStartX = useRef(null);
  const total = slides?.length || 0;

  const ir = useCallback((idx) => {
    setAtual(((idx % total) + total) % total);
  }, [total]);

  const resetTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setAtual(a => (a + 1) % total);
    }, 5000);
  }, [total]);

  useEffect(() => {
    if (total > 1) resetTimer();
    return () => clearInterval(timerRef.current);
  }, [total, resetTimer]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    clearInterval(timerRef.current);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      ir(diff > 0 ? atual + 1 : atual - 1);
    }
    resetTimer();
    touchStartX.current = null;
  };

  if (!slides || total === 0) return null;

  const slide = slides[atual];

  const handleCta = () => {
    if (!slide.link) return;
    window.open(slide.link, '_blank', 'noopener,noreferrer');
  };

  const corBase = slide.corFundo || '#2f2b5f';

  return (
    <div className="carrossel-wrapper">
      <div
        className="carrossel-slide"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{
          background: slide.imagem
            ? `url(${slide.imagem}) center/cover no-repeat`
            : corBase,
        }}
      >
        {/* Degradê na cor do slide */}
        {slide.imagem && (
          <div
            className="carrossel-overlay"
            style={{
              background: `linear-gradient(to bottom, transparent 50%, ${corBase}88 85%, ${corBase}cc 100%)`,
            }}
          />
        )}

        <div className="carrossel-content">
          {slide.subtitulo && (
            <p className="carrossel-subtitulo">{slide.subtitulo}</p>
          )}
          <h2 className="carrossel-titulo">{slide.titulo}</h2>
          {slide.cta && slide.link && (
            <button className="btn carrossel-cta" onClick={handleCta}>
              {slide.cta}
            </button>
          )}

          {/* Dots dentro do slide para preservar border-radius */}
          {total > 1 && (
            <div className="carrossel-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={`carrossel-dot${i === atual ? ' ativo' : ''}`}
                  onClick={() => { ir(i); resetTimer(); }}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
